export interface HttpOptions {
  headers?: { [name: string]: string };
  timeout?: number;
  retries?: number;
  retryDelay?: number;
}
